module.exports = __webpack_public_path__ + "s/img/Glam_D_1.28333ba4.jpg";